import {
  personalVehicleInfo,
  velotrackVehicleInfo,
} from "../../../../common/helpers/vehicle-edit-constants";
import { GenericInfoField } from "../../../../common/components/ui/GenericInfoField";
import { useVehicleDashboardContext } from "./useVehicleDashboardContext";

function VehicleInfo() {
  const { vehicle } = useVehicleDashboardContext();
  const setpersonalVehicleInfo = personalVehicleInfo(vehicle);
  const setVelotrackVehicleInfo = velotrackVehicleInfo(vehicle);

  return (
    <>
      <h2 className="text-2xl font-semibold mb-4">Informações do veículo</h2>
      <section className="col-span-full bg-gray/20 dark:text-black p-4 rounded-md">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 grid-rows-3 gap-2">
          {setpersonalVehicleInfo.map((info) => {
            return (
              <GenericInfoField
                id={info.id}
                spanSize={info.spanSize}
                label={info.label}
                value={info.value}
              />
            );
          })}
        </div>

        <h2 className="text-2xl font-semibold mt-8 mb-4">Integrações</h2>
        <div className="">
          {setVelotrackVehicleInfo.map((info) => {
            return (
              <div className="grid grid-cols-3 gap-2 mb-8">
                <div className="col-span-2">
                  <GenericInfoField
                    id={info.id}
                    spanSize={info.spanSize}
                    label={info.label}
                    value={info.value}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
export default VehicleInfo;
